import React, { useState } from "react";

import Button from "../Button";
import Comment from "../../components/Comment";
import { CommentProps } from "../Comment/Comment";
import ProfileImage from "../ProfileImage";
import Textarea from "../../components/Textarea";
import useCurrentUser from "../../hooks/useCurrentUser";

export interface CommentsSectionProps {
  comments: CommentProps[];
  onNewComment: (comment: string) => void;
}

const CommentsSection = ({ comments, onNewComment }: CommentsSectionProps) => {
  const [comment, setComment] = useState("");

  // Get user image
  const currentUser = useCurrentUser();
  const { image } = currentUser || {};

  return (
    <div className="w-fulls">
      <div className="text-lg font-medium text-aqua">Comments</div>
      <div className="text-xs text-gray-400">
        Sign in to your account to add comments.
      </div>
      <div className="flex mt-4">
        <div className="w-1/12 mr-4">
          <ProfileImage src={image} />
        </div>
        <div className="w-full">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setComment("");
              onNewComment(comment);
            }}
          >
            <Textarea
              value={comment}
              placeholder="Type a comment..."
              onChange={(e) => setComment(e.target.value)}
            />
            <div className="mt-4">
              <Button type="submit">Add Comment</Button>
            </div>
          </form>
        </div>
      </div>

      <div className="mt-4">
        {comments && comments.length ? (
          comments
            .map((comment, key) => <Comment key={key} {...comment} />)
            .reverse()
        ) : (
          <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
            No comments.
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentsSection;
